import {
  formatAutoTaggingPlanValues,
  getConceptDisplayLabel,
  resolvePlanSubTypeDisplayName,
  resolvePlanTypeDisplayName,
  type AutoTaggingPlanRecord,
  type AutoTaggingPlanTypeOption,
  type ConfigurableConcept,
} from "../../../services/autoTaggingService";
import type { TaggingPlanRow } from "../constants";
import {
  hydrateReferenceFromPlan,
  mapPlanConfigFromRecord,
} from "./classificationPlanApiMapping";

export function mapTaggingPlanRow(
  plan: AutoTaggingPlanRecord,
  planTypes: AutoTaggingPlanTypeOption[] = [],
  concepts: ConfigurableConcept[] = [],
): TaggingPlanRow {
  const conceptMeta = concepts.find(
    (item) => item.code === plan.concept || item.name === plan.concept,
  );
  const reference = hydrateReferenceFromPlan(plan);
  const config = mapPlanConfigFromRecord(plan);
  const objectSubTypeName =
    reference.objectSubTypeName.trim() ||
    resolvePlanSubTypeDisplayName(
      planTypes,
      plan.target_type,
      reference.objectSubType,
    );

  return {
    id: plan.id,
    objectType: plan.target_type,
    objectSubType: reference.objectSubType,
    objectTypeName: resolvePlanTypeDisplayName(planTypes, plan.target_type),
    objectSubTypeName,
    referenceConceptCode: reference.referenceConceptCode,
    referenceConceptDisplayName: reference.referenceConceptDisplayName,
    referenceDimensions: reference.referenceDimensions.map((dim) => ({
      conceptCode: dim.conceptCode,
      conceptDisplayName: dim.conceptDisplayName,
      values: dim.values.map((value) => ({
        code: value.code,
        name: value.name,
        description: String(value.description ?? ""),
      })),
      allValues: dim.allValues,
    })),
    conceptCode: plan.concept,
    concept: conceptMeta
      ? getConceptDisplayLabel(conceptMeta)
      : plan.concept,
    values: formatAutoTaggingPlanValues(plan),
    name: plan.name,
    assessmentType: plan.assessment_type,
    description: plan.prompt,
    enabled: plan.active,
    allValues: plan.all_values,
    conceptValues: plan.concept_values,
    taggingApproach: config.taggingApproach,
    execution: config.execution,
    layer: plan.layer,
    assessmentTemplate: config.assessmentTemplate,
    updateAssessmentRecordConcept: config.updateAssessmentRecordConcept,
    updateAssessmentRecords: config.updateAssessmentRecords,
  };
}
